// extracted by mini-css-extract-plugin
module.exports = {"component":"PreLine_component__1SR4U"};